<template lang="html">
  <div class="addAddress">
    <!-- <div class="back">
    <a @click="back">< address list</a>
  </div> -->
  <a @click="close">
    <svg class="closelogin"><use xlink:href="#close"/></svg>
  </a>
  <!-- <div class="close">
  <a @click="close"><img src="@/assets/close-cross.svg"/></a>
</div> -->
<div style="clear:both;"/>
<div style="textAlign:center">
  <a class="bck" @click="back"><img src="@/assets/back.svg"/></a>
  <h1>{{commitType == 0 ? 'Add address' : 'Edit Address'}}</h1></br>
</div>
<div class="wrapper">
<label>Recipient</label>
<input type="text" v-model="address.name" placeholder="Enter a name">
<label>Phone</label>
<input type="text" v-model="address.phone" placeholder="Enter a phone number">
<label>Country</label>
<select v-model="address.country" @change="(e) => getProvince(e.srcElement.value)">
  <option value="" disabled selected>choose country</option>
  <option v-for="item in country" :value="item.country_id">{{item.name}}</option>
</select>
<label>Province</label>
<input type="text" v-model="address.province" placeholder="Province">
<label>City</label>
<input type="text" v-model="address.city" placeholder="City">
<label>Area</label>
<input type="text" v-model="address.area" placeholder="Area/District">
<!-- <label>Province</label>
<select v-model="address.province" @change="(e) => getCity(e.srcElement.value)">
<option value="" disabled selected>choose province</option>
<option v-for="item in province" :value="item.id" :selected="item.id == address.province">{{item.name}}</option>
</select>
<label>City</label>
<select v-model="address.city" @change="(e) => getArea(e.srcElement.value)">
<option value="" disabled selected>choose city</option>
<option v-for="item in city" :value="item.id" :selected="item.id == address.city">{{item.name}}</option>
</select>
<label>Area</label>
<select v-model="address.area" @change="(e) => setArea(e.srcElement.value)">
<option value="" disabled selected>choose area</option>
<option v-for="item in area" :value="item.id" :selected="item.id == address.area"> {{item.name}}</option>
</select> -->
<label>Address detail</label>
<textarea v-model="address.address" placeholder="Enter more information about your address"></textarea>
<label>Set address as default?</label>
<p class="button yes" :class="{active: address.status == 1}" @click="address.status = 1">Yes</p>
<p class="button no" :class="{active: address.status == 0}" @click="address.status = 0">No</p>
<!-- <input type="radio" value="1" v-model="address.status">Yes
<input type="radio" value="0" v-model="address.status">No -->
</div>
<p class="button save" @click="save">Save</p>

<!-- SVG -->
<svg display="none">
  <symbol width="15px" height="15px" viewBox="0 0 41.756 41.756" id="close">
    <path d="M27.948,20.878L40.291,8.536c1.953-1.953,1.953-5.119,0-7.071c-1.951-1.952-5.119-1.952-7.07,0L20.878,13.809L8.535,1.465
    c-1.951-1.952-5.119-1.952-7.07,0c-1.953,1.953-1.953,5.119,0,7.071l12.342,12.342L1.465,33.22c-1.953,1.953-1.953,5.119,0,7.071
    C2.44,41.268,3.721,41.755,5,41.755c1.278,0,2.56-0.487,3.535-1.464l12.343-12.342l12.343,12.343
    c0.976,0.977,2.256,1.464,3.535,1.464s2.56-0.487,3.535-1.464c1.953-1.953,1.953-5.119,0-7.071L27.948,20.878z"/>
  </symbol>
</svg>
<!-- #### -->
</div>
</template>

<script>
import axios from 'axios';
import {GetCountry, GetProvince, GetCity, GetArea, AddAddress, EditAddress, GetAddress} from '@/api/index.js'
import vpinyin from '@/utils/pinyin/vue-py.js'
export default {
  data(){
    return{
      userCountry:null,
      commitType:0,
      country: null,
      province: null,
      city: null,
      area: null,
      address:{
        id: null,
        name: null,
        phone: null,
        country: null,
        province: null,
        city: null,
        area: null,
        address: null,
        status: 0,
      }
    }
  },
  props:{
    addId:{
      type:String,
    },
  },
  created(){
    if(this.addId){
      GetAddress({'id':this.addId}).then(res => {
        if(res.data.length <= 0){
          this.initData();
        } else{
          this.commitType = 1;
          this.editInitData(res.data);
        }
      })
    }
    else{
      this.initData();
    }
  },
  methods:{
    editInitData(addr){
      this.address = addr;
      let that = this;
      GetCountry().then(res => {
        this.country = res.data;
        for(let i = 0; i < this.country.length; i++){
          this.country[i].py = vpinyin.chineseToPinYin(this.country[i].name);
          if(this.country[i].name == this.address.country){
            this.address.country = this.country[i].country_id;
            getProvince(this.address.country);
          }
        }

        let temp = null;
        for(let i = 0; i < this.country.length; i++){
          for(let j = i + 1; j < this.country.length; j++){

            if(this.country[i].py.substring(0,1) > this.country[j].py.substring(0,1)){
              temp = this.country[i];
              this.country[i] = this.country[j];
              this.country[j] = temp;
              temp = null;
            }
          }
        }
      })

      function getProvince(val){
        GetProvince({'country_id': val}).then(res => {
          that.province = res.data;

          for(let i = 0; i < that.province.length; i++){
            if(that.province[i].name == that.address.province){
              that.address.province = that.province[i].id;
              getCity(that.address.province);
              break;
            }
          }
        })
      }

      function getCity(val){
        GetCity({'province_id': val}).then(res => {
          that.city = res.data;

          for(let i = 0; i < that.city.length; i++){
            if(that.city[i].name == that.address.city){
              that.address.city = that.city[i].id;
              getArea(that.address.city);
              break;
            }
          }
        })
      }

      function getArea(val){
        GetArea({'city_id': val}).then(res => {
          that.area = res.data;

          for(let i = 0; i < that.area.length; i++){
            if(that.area[i].name == that.address.area){
              that.address.area = that.area[i].id;
              break;
            }
          }
        })
      }
    },

// ENDDD

    save(){
      let addr = this.address;
      for(let k in addr){
        if(addr[k] == null || addr[k] == '--'){
          if(k == 'province' || k == 'city' || k == 'area'){
            if(addr.country == '中国' || addr.country == 40){
              this.$message({
                message: '请确认输入内容填写完整',
                type: 'warning',
                showClose: true,
                position: 'center',
              })
              return;
            }else{
              addr[k] = '--';
            }
          }else if(k == 'id' && this.commitType == 0){
            console.log('ID 为 null');
          }else{
            this.$message({
              message: '请确认输入内容填写完整',
              type: 'warning',
              showClose: true,
              position: 'center',
            })
            return;
          }
        }

        // if(k == 'phone'){
        //   let reg = /^1(3|4|5|7|8)\d{9}$/;
        //   if(!reg.test(addr[k])){
        //     this.$message({
        //       message: '手机号码有误',
        //       type: 'warning',
        //       showClose: true,
        //       position: 'center',
        //     })
        //     return;
        //   }
        // }
      }

      if(addr.country){
        for (var i = 0; i < this.country.length; i++) {
          if(addr.country == this.country[i].country_id){
            addr.country = this.country[i].name;
            break;
          }
        }
      }
      if(addr.province && addr.country == '中国'){
        for (var i = 0; i < this.province.length; i++) {
          if(addr.province == this.province[i].id){
            addr.province = this.province[i].name;
            break;
          }
        }
      }
      if(addr.city && addr.country == '中国'){
        for (var i = 0; i < this.city.length; i++) {
          if(addr.city == this.city[i].id){
            addr.city = this.city[i].name;
            break;
          }
        }
      }
      if(addr.area && addr.country == '中国'){
        for (var i = 0; i < this.area.length; i++) {
          if(addr.area == this.area[i].id){
            addr.area = this.area[i].name;
            break;
          }
        }
      }

      if(this.commitType == 0){
        AddAddress({'name': this.address.name,
        'phone':this.address.phone,
        'country':this.address.country,
        'province':this.address.province,
        'city':this.address.city,
        'area':this.address.area,
        'address':this.address.address,
        'status':this.address.status,
      }).then(res => {
        console.log('country id:' + this.address.country);
        window.alert('address successfully added!');
        this.back();
      })
    }else{
      EditAddress({
        'id': addr.id,
        'name': addr.name,
        'phone': addr.phone,
        'country': addr.country,
        'province': addr.province,
        'city': addr.city,
        'area': addr.area,
        'address': addr.address,
        'status': addr.status
      }).then(res => {
        window.alert('address successfully updated');
        this.back();
      })
    }

  },
  close(){
    this.$emit('close');
    this.commitType = 0;
  },
  back(){
    this.$emit('back');
    this.commitType = 0;
  },
  initData(){
    this.getUserCountry(this.getAllCountry);
  },
  getProvince(val){
    this.address.country = val;
    this.address.province = null;
    this.address.city = null;
    this.address.area = null;
    GetProvince({'country_id': val}).then(res => {
      this.province = res.data;
      this.city = null;
      this.area = null;

      if(this.province.length <= 0){
        this.city = [];
        this.area = [];
      }else{
        this.city = null;
        this.area = null;
      }
    })
  },
  getCity(val){
    this.address.province = val;
    this.address.city = null;
    this.address.area = null;
    GetCity({'province_id': val}).then(res => {
      this.city = res.data;
      this.area = null;
    })
  },
  getArea(val){
    this.address.city = val;
    this.address.area = null;
    GetArea({'city_id': val}).then(res => {
      this.area = res.data;
    })
  },
  setArea(val){
    this.address.area = val;
  },
  getUserCountry(){
    console.log('user country triggered!')
    axios.get('http://api.ipstack.com/check?access_key=341a88b0df9a9704bbc67cf7f39c97f1&fields=country_name').then(response => {
      this.userCountry = response.data.country_name;
      console.log('API success: ' + this.userCountry);

      if(arguments.length > 0){
        arguments[0]()
      }
    }).catch(error =>{
      console.log('error from user country API: ' + error);
      this.userCountry = null;
    })
  },
  getAllCountry(){
    GetCountry({}).then(res => {
      this.country = res.data;
      console.log(this.userCountry);
      for(let k in this.country){
        if(this.country[k].name == this.userCountry){
          this.address.country = this.country[k].country_id;
        }
      }
    })
  }
},
}
</script>

<style lang="css" scoped>
.addAddress{
  width:550px;
  overflow: hidden;
  position: fixed;
  color:#000;
  top:10vh;
  background:#fff;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.16);
  left:50%;
  transform:translateX(-50%);
  padding: 40px 20px 20px;
  text-align: left;
  border-radius: 20px;
  height: 600px;
  /* overflow: auto; */
  z-index: 110;
}

.wrapper{
  height: 500px;
  overflow:auto;
}

h1{
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  color:#3C4245;
  /* margin-bottom: 40px;
  margin-top: 60px; */
}
.bck img{
  width: 20px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

.bck:hover{
  cursor: pointer;
}

label{
  display: block;
  margin-bottom: 5px;
  font-size: 16px!important;
  color:#3C4245;
}
input[type="text"]{
  border-radius: 30px;
  margin-right: 20px;
  width: 88%;
  padding: 5px 10px;
  border:1px solid rgba(0, 0, 0, 0.5);
}
input, select{
  margin-left: 4%;
  border: none;
}
select,input,textarea:focus{
  outline: none;
}

select{
  width: 92%;
  padding: 5px 10px;
  border-radius: 30px;
  margin-left: 4%;
  border:1px solid rgba(0, 0, 0, 0.5);
}

label{
  font-size: 18px;
  margin-top: 20px;
  font-weight: bold;
  margin-left: 4%;
}
textarea{
  margin-left: 4%;
  width: 90%;
  height: 80px;
  border-radius: 7px;
  padding: 5px 10px;
  border:1px solid rgba(0, 0, 0, 0.5);
}
.left{
  float:left;
}
.right{
  float: right;
}
.button{
  background: #9f9f9f;
  width: 92%;
  text-align: center;
  padding: 15px 0;
  border-radius: 7px;
  margin-left: 4%;
}
.back{
  float: left;
}
.close{
  float:right;
}
.close img{
  width: 15px;
}

svg{
  width: 16px;
  height: 15px;
  position: absolute;
  right: 0;
  top: 10px;
  margin:10px 30px 0 0
}
svg:hover{
  fill:#719192;
  cursor: pointer;
}
.yes, .no{
  margin:0;
  margin-top: 10px;
  width: 14%;
  font-size: 14px;
  padding:10px 0;
  display: inline-block;
  margin-bottom: 20px;
  border-radius: 10px;
}
.yes{
  margin-left:20px;
  margin-right: 10px;
}
.active{
  background: #719192;
  color:#eee;
}

.save{
  background: #5F6769;
  color:#eee;
  margin-bottom: 20px;
}
.button:hover{
  background: #719192;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/Components/AddAddress.vue